export const LogoMark = ({ size = 28, dark = false, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    aria-hidden="true"
    data-testid="logo-mark"
  >
    <rect width="64" height="64" fill={dark ? "#FFFFFF" : "#0A0A0A"} />
    <circle
      cx="32"
      cy="32"
      r="17"
      fill="none"
      stroke={dark ? "#0A0A0A" : "#FFFFFF"}
      strokeWidth="5"
      strokeDasharray="7 6"
    />
    <rect
      x="8"
      y="28.5"
      width="48"
      height="7"
      fill="#E60000"
      transform="rotate(-45 32 32)"
    />
  </svg>
);
